import { IconCross } from '../../icons/IconCross';
import IconSearch from '../../icons/IconSearch';
import type { DocumentFilters } from '../DocumentFilters';
import type { DocumentPagesFilters } from '../DocumentPagesFilters';

export default function ProjectIdInputFilter({
  filters,
  handleProjectIdChange,
}: {
  filters: DocumentFilters | DocumentPagesFilters;
  handleProjectIdChange: (value: string) => void;
}) {
  return (
    <>
      {/* Search Input */}
      <div className="flex flex-col gap-2 justify-between">
        <label htmlFor="projectId" className="block text-sm font-medium text-gray-700  dark:text-zinc-100 mb-1">
          Project ID
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <IconSearch className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            id="projectId"
            value={filters.projectId}
            onChange={(e) => handleProjectIdChange(e.target.value)}
            placeholder="Project ID"
            className="block w-full pl-10 pr-8 py-2 border border-gray-300 dark:border-zinc-700 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 truncate"
          />
          {filters.projectId && (
            <button
              onClick={() => handleProjectIdChange('')}
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
            >
              <IconCross className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            </button>
          )}
        </div>
      </div>
    </>
  );
}
